export const language = {
  zh: {
    'Confirm': '确认',
    'Edit': '编辑',
    'Save': '保存',
    'Cancel': '取消',
    'Please Entry': '请输入',
    'Operation': '操作',
    'Search': '搜索',
    'Reset': '重置',
    'Status': '状态',
    'On': '启用',
    'Off': '禁用',
    'Yes': '是',
    'No': '否',
    'UserName': '员工姓名',
    'User Phone Number': '员工手机号',
    'User Email ': '员工邮箱',
    'Account found': '已搜索到帐号',
    'Confirm link': '确认关联',
    'No account was searched': '未搜索到帐号',
    'Wait for confirm': '待员工确认关联',
    'Refuse to link': '员工拒绝关联',
    'Relink': '重新关联',
    'Unlink': '取消关联',
    'Application time': '申请时间',
    'Link Account': '账号关联',
  },
  en: {
    'Confirm': 'Confirm',
    'Edit': 'Edit',
    'Save': 'Save',
    'Cancel': 'Cancel',
    'Please Entry': 'Please Entry',
    'Operation': 'Operation',
    'Status': 'Status',
    'UserName': 'UserName',
    'User Phone Number': 'User Phone Number',
    'User Email ': 'User Email',
    'Account found': 'Account found',
    'Confirm link': 'Confirm link',
    'No account was searched': 'No account was searched',
    'Wait for confirm': 'Wait for confirm',
    'Refuse to link': 'Refuse to link',
    'Relink': 'Relink',
    'Application time': 'Application time',
    'Unlink': 'Unlink',
    'Link Account': 'Link Account',
  }
};
